import { PATH_LABELS } from '@/constants/routes'
import type { BreadcrumbItemType } from '@/types/breadcrumb/breadcrumb-item-type'
import { hyphenToUnderscore } from '@/utils/hyphen-to-underscore'
import { isUUIDv4 } from '@/utils/is-uuid-v4'
import { useNavigate } from 'react-router-dom'

export const useBreadcrumb = () => {
  const navigate = useNavigate()

  function generateBreadcrumb(
    setBreadcrumb: (items: BreadcrumbItemType[]) => void,
    setHasBreadcrumb: (value: boolean) => void
  ) {
    const labelRoutes: BreadcrumbItemType[] = []
    const currentPath = location.pathname.split('/').filter(Boolean)

    for (const path of currentPath) {
      if (isUUIDv4(path) || !Number.isNaN(parseInt(path))) {
        break
      }

      labelRoutes.push({
        route: path,
        label: PATH_LABELS[hyphenToUnderscore(path) as keyof typeof PATH_LABELS]
      })
    }

    setBreadcrumb(labelRoutes)
    setHasBreadcrumb(labelRoutes.length > 1)
  }

  function getBreadcrumbPath(breadcrumb: BreadcrumbItemType[], index: number) {
    const items = breadcrumb.slice(0, index + 1)
    let path = '/'
    items.forEach((item, eachIndex) => {
      path += item.route
      if (eachIndex < items.length) {
        path += '/'
      }
    })

    return path
  }

  function handleBackBreadcrumb() {
    const currentPath = location.pathname.split('/').filter(Boolean)
    if (currentPath.length > 1) {
      currentPath.pop()
      navigate(`/${currentPath.join('/')}`)
    }
  }
  return {
    actions: {
      handleBackBreadcrumb,
      getBreadcrumbPath,
      generateBreadcrumb
    }
  }
}
